export const ERROR_TYPE_LABELS = {
  can_imu_missing_err: 'IMU Missing',
  can_imu_count_err: 'IMU Missing',
  can_msg_exists_err: 'No CAN Messages',
  gnss_position_err: 'No GNSS Position',
  gnss_satellite_err: 'No GNSS Satellite',
  ntrip_err: 'NTRIP Error',
  rtk_err: 'RTK Error',
  gnss_precision_err: 'Poor GNSS Precision',
  emcy_msg_err: 'EMCY Msg',
  can_bus_error_err: 'CAN Bus Error',
  can_bus_off_err: 'CAN Bus Off',
  can_stuck_dominant_err: 'CAN Stuck Dominant',
};

export const CHART_COLORS = ['#d64545', '#eb6a42', '#f2a541', '#4d8cf5', '#5fb49c'];

export function formatDuration(minutes) {
  if (minutes === null || minutes === undefined || minutes === 0) {
    return '0 min';
  }
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
}

// Percentages are shown to one decimal. Round a ratio to that precision once
// (tenths of a percent, half up) and derive complementary parts by subtraction
// from these integers, so the parts shown always add up to the whole shown.
export function percentTenths(ratio) {
  return Math.round((ratio || 0) * 1000);
}

export function formatPercentTenths(tenths) {
  return `${(tenths / 10).toFixed(1)}%`;
}

export function formatPercent(ratio) {
  return formatPercentTenths(percentTenths(ratio));
}

// CAN-based error types are stored per bus as "<type>_<can_id>", e.g.
// "can_msg_exists_err_2". Split that suffix off so the family label still applies.
export function splitErrorType(errorType) {
  const match = /^(.*)_(\d+)$/.exec(errorType || '');
  if (match && ERROR_TYPE_LABELS[match[1]]) {
    return { baseType: match[1], canId: match[2] };
  }
  return { baseType: errorType, canId: null };
}

export function getErrorTypeLabel(errorType) {
  const { baseType, canId } = splitErrorType(errorType);
  const label = ERROR_TYPE_LABELS[baseType] || errorType;
  return canId === null ? label : `${label} (CAN ${canId})`;
}
